var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', {
    class: "".concat(_vm.cardClass, " ").concat(_vm.visible ? 'open' : ''),
    attrs: {
      "no-body": ""
    },
    on: {
      "mouseenter": _vm.collapseOpen,
      "mouseleave": _vm.collapseClose
    }
  }, [_c('b-card-header', {
    class: "".concat(_vm.classHeader, " ").concat(!_vm.visible ? 'collapsed rounded-8px' : ''),
    attrs: {
      "header-bg-variant": _vm.headerBgVariant,
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": _vm.collapseItemID,
      "role": "tab",
      "data-toggle": "collapse"
    },
    on: {
      "click": function click($event) {
        return _vm.updateVisible(!_vm.visible);
      }
    }
  }, [_vm._t("header", [_c('span', {
    staticClass: "lead collapse-title mr-1"
  }, [_vm._v(_vm._s(_vm.title))])])], 2), _c('b-collapse', {
    attrs: {
      "id": _vm.collapseItemID,
      "accordion": _vm.accordion,
      "role": "tabpanel"
    },
    model: {
      value: _vm.visible,
      callback: function callback($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('b-card-body', {
    attrs: {
      "body-class": _vm.classBody
    }
  }, [_vm._t("default")], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }